import { route, tag, type PageTour } from '../pageTour';

export const siteDashboardTour: PageTour = {
  id: 'page-site-dashboard',
  version: 1,
  title: 'Site Dashboard',
  summary: 'This site\'s cameras, alerts and activity on one page.',
  match: route('/site-dashboard'),
  steps: [
    {
      target: tag('dashboard-board-customize'),
      title: 'Customize layout',
      description: 'Move, resize, hide or bring back cards so the board shows what matters to you at this site.',
      side: 'bottom',
    },
    {
      target: tag('dashboard-board-refresh'),
      title: 'Refresh',
      description: 'Reload every card now. The board also updates itself every few seconds.',
      side: 'bottom',
    },
    {
      target: tag('dashboard-board-cards'),
      title: 'Site at a glance',
      description: 'Each card sums up one part of this site, such as alerts, cameras or detections. Click an item to see its details, or the arrow on a card to open the full page.',
      side: 'top',
    },
  ],
};
